/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MemberCodeVo
 */
export interface MemberCodeVo {
    /**
     * 推荐码id
     * @type {number}
     * @memberof MemberCodeVo
     */
    recommendCodeId?: number;
    /**
     * 推荐码
     * @type {string}
     * @memberof MemberCodeVo
     */
    code?: string;
    /**
     * 会员id
     * @type {number}
     * @memberof MemberCodeVo
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof MemberCodeVo
     */
    userName?: string;
    /**
     * 会员编号
     * @type {string}
     * @memberof MemberCodeVo
     */
    userCode?: string;
    /**
     * 当前适用日期
     * @type {string}
     * @memberof MemberCodeVo
     */
    applyDate?: string;
}

/**
 * Check if a given object implements the MemberCodeVo interface.
 */
export function instanceOfMemberCodeVo(value: object): value is MemberCodeVo {
    return true;
}

export function MemberCodeVoFromJSON(json: any): MemberCodeVo {
    return MemberCodeVoFromJSONTyped(json, false);
}

export function MemberCodeVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MemberCodeVo {
    if (json == null) {
        return json;
    }
    return {
        
        'recommendCodeId': json['recommendCodeId'] == null ? undefined : json['recommendCodeId'],
        'code': json['code'] == null ? undefined : json['code'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'userCode': json['userCode'] == null ? undefined : json['userCode'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
    };
}

export function MemberCodeVoToJSON(json: any): MemberCodeVo {
    return MemberCodeVoToJSONTyped(json, false);
}

export function MemberCodeVoToJSONTyped(value?: MemberCodeVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'recommendCodeId': value['recommendCodeId'],
        'code': value['code'],
        'userId': value['userId'],
        'userName': value['userName'],
        'userCode': value['userCode'],
        'applyDate': value['applyDate'],
    };
}

